<template>
    <div>
        <app-layout>
            <!-- Header -->
            <template v-slot:header>
                <Header title="Co-op/ Business Point"
                        :isFilter="true"
                        @filter-div-status="datatable.filterStatus = $event"
                        :actionButtons="headerActionButtons" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile title="Co-op/ Business Point"
                              :isFilter="true"
                              @filter-div-status="datatable.filterStatus = $event"
                              :actionButtons="headerActionButtons" />
            </template>

            <!-- Filters -->
            <datatable-filter v-show="datatable.filterStatus"
                              :exportExcel="true"
                              :jsonExcelButton="true"
                              :jsonExcelData="datatable.rows"
                              :jsonExcelFields="excelFields"
                              @filter="filter"
                              @filterClear="filterClear">
                <b-row>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('coop_faculty')">
                            <b-form-input v-model="datatable.queryParams.filter.faculty" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('coop_department')">
                            <b-form-input v-model="datatable.queryParams.filter.department" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('class') || 'Sınıf'">
                            <b-form-input v-model="datatable.queryParams.filter.class_level" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('academic_year')">
                            <b-form-input v-model="datatable.queryParams.filter.academic_year" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('semester') || 'Dönem'">
                            <b-form-input v-model="datatable.queryParams.filter.semester" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('status')">
                            <b-form-select v-model="datatable.queryParams.filter.status" :options="statusOptions">
                                <template #first>
                                    <b-form-select-option :value="null">-- {{ $t('status') }} --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input v-model="datatable.queryParams.filter.student_number" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="6" class="mb-2">
                        <b-form-group :label="$t('company_name')">
                            <b-form-input v-model="datatable.queryParams.filter.company_name" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <!-- Datatable -->
            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       :lineNumbers="false"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"
                       title="COOP Business Point Katılımcılar"
            />
        </app-layout>

        <!-- Columns Toggle Modal -->
        <CommonModal ref="columnsModal" size="md" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                {{ $t('coop_columns') }}
            </template>
            <template v-slot:CommonModalContent>
                <div class="p-2">
                    <div v-for="col in togglableColumns" :key="col.field" class="mb-3">
                        <b-form-checkbox :checked="!col.hidden" @change="toggleColumnVisibility(col)">
                            {{ col.label }}
                        </b-form-checkbox>
                    </div>
                </div>
            </template>
        </CommonModal>

        <!-- Reschedule Calendar Modal (Görüntüle) -->
        <CommonModal ref="rescheduleModal" size="md" :onHideOnlyX="true">
            <template v-slot:CommonModalTitle>
                Randevu Saatini Değiştir
            </template>
            <template v-slot:CommonModalContent>
                <div class="p-3" v-if="rescheduleForm.id">
                    <b-form-group label="Yeni Randevu Saati Seçin" class="mb-3">
                        <b-form-select v-model="rescheduleForm.time" :options="slotOptions" />
                    </b-form-group>
                    <div class="text-right">
                        <b-button variant="primary" class="px-4" @click="saveReschedule">
                            Kaydet
                        </b-button>
                        <b-button variant="secondary" class="ml-2" @click="$refs.rescheduleModal.$refs.commonModal.hide()">
                            İptal
                        </b-button>
                    </div>
                </div>
            </template>
        </CommonModal>
    </div>
</template>

<script>
    import AppLayout from "@/layouts/AppLayout";
    import Header from "@/layouts/AppLayout/Header";
    import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
    import Datatable from "@/components/datatable/Datatable";
    import DatatableFilter from "@/components/datatable/DatatableFilter";
    import CommonModal from "@/components/elements/CommonModal";
    import CoopBusinessPointService from "@/services/CoopBusinessPointService";
    import qs from "qs";

    export default {
        name: "CoopBusinessPointParticipants",
        components: {
            AppLayout,
            Header,
            HeaderMobile,
            Datatable,
            DatatableFilter,
            CommonModal
        },
        data() {
            return {
                rescheduleForm: {
                    id: null,
                    time: ""
                },
                slotOptions: [],
                excelFields: {
                    "Öğrenci No": "student_number",
                    "Firma": "company_name",
                    "Konuşmacı": "speaker",
                    "Ad": "student_name",
                    "Soyad": "student_surname",
                    "Bölüm": "department",
                    "Katılım": "quota_label",
                    "Randevu Saati": "appointment_time",
                    "CV": "cv_name"
                },
                statusOptions: [
                    { value: "Aktif", text: "Aktif" },
                    { value: "Pasif", text: "Pasif" }
                ],
                datatable: {
                    isLoading: false,
                    filterStatus: true,
                    columns: [
                        {
                            label: "",
                            field: "buttons",
                            html: true,
                            hidden: false,
                            tdClass: "p-0 text-center w-40 align-middle",
                            buttons: [
                                {
                                    text: "Katılımı Sil",
                                    class: "ri-delete-bin-line text-danger",
                                    callback: (row) => {
                                        this.deleteParticipation(row.id);
                                    }
                                },
                                {
                                    text: "Görüntüle",
                                    class: "ri-eye-line text-info",
                                    callback: (row) => {
                                        this.openRescheduleModal(row);
                                    }
                                },
                                {
                                    text: "Cv indir",
                                    class: "ri-download-line text-primary",
                                    callback: (row) => {
                                        this.downloadCv(row);
                                    }
                                }
                            ]
                        },
                        {
                            label: "Öğrenci No",
                            field: "student_number",
                            hidden: false
                        },
                        {
                            label: "Firma",
                            field: "company_name",
                            hidden: false
                        },
                        {
                            label: "Konuşmacı",
                            field: "speaker",
                            hidden: false
                        },
                        {
                            label: "Ad",
                            field: "student_name",
                            hidden: false
                        },
                        {
                            label: "Soyad",
                            field: "student_surname",
                            hidden: false
                        },
                        {
                            label: "Bölüm",
                            field: "department",
                            hidden: false
                        },
                        {
                            label: "Katılım",
                            field: "quota_label",
                            hidden: false
                        },
                        {
                            label: "Randevu Saati",
                            field: "appointment_time",
                            hidden: false
                        },
                        {
                            label: "CV",
                            field: "cv_name",
                            hidden: false,
                            html: true,
                            format: (val) => {
                                return `<u>${val}</u>`;
                            }
                        }
                    ],
                    rows: [],
                    total: 0,
                    showTable: false,
                    queryParams: {
                        filter: {
                            faculty: "",
                            department: "",
                            class_level: "",
                            academic_year: "",
                            semester: "",
                            status: null,
                            student_number: "",
                            company_name: ""
                        },
                        sort: "id",
                        page: 1,
                        limit: 20
                    }
                }
            };
        },
        computed: {
            headerActionButtons() {
                return [
                    {
                        text: this.$t("coop_columns"),
                        callback: this.openColumnsModal
                    }
                ];
            },
            togglableColumns() {
                return this.datatable.columns.filter(col => col.field !== "buttons");
            }
        },
        methods: {
            onPageChange(params) {
                this.datatable.queryParams.page = params.currentPage;
                this.getRows();
            },
            onPerPageChange(params) {
                this.datatable.queryParams.limit = params.currentPerPage;
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            onSortChange(params) {
                const sortType = params[0].type == "desc" ? "-" : "";
                this.datatable.queryParams.sort = sortType + params[0].field;
                this.getRows();
            },
            filter() {
                this.datatable.queryParams.page = 1;
                this.getRows();
            },
            filterClear() {
                this.datatable.queryParams.filter = {
                    faculty: "",
                    department: "",
                    class_level: "",
                    academic_year: "",
                    semester: "",
                    status: null,
                    student_number: "",
                    company_name: ""
                };
                this.getRows();
            },
            getRows() {
                this.datatable.showTable = true;
                this.datatable.isLoading = true;

                const config = {
                    sessionId: this.$route.params.id,
                    params: {
                        ...this.datatable.queryParams
                    },
                    paramsSerializer: (params) => qs.stringify(params, { encode: false })
                };

                return CoopBusinessPointService.getParticipants(config)
                    .then((response) => {
                        this.datatable.rows = response.data.data;
                        this.datatable.total = response.data.pagination.total;
                    })
                    .finally(() => {
                        this.datatable.isLoading = false;
                    });
            },
            openColumnsModal() {
                this.$refs.columnsModal.$refs.commonModal.show();
            },
            toggleColumnVisibility(col) {
                col.hidden = !col.hidden;
            },
            openRescheduleModal(row) {
                this.rescheduleForm = {
                    id: row.id,
                    time: row.appointment_time
                };
                CoopBusinessPointService.getSlots().then((res) => {
                    this.slotOptions = res.data.map(slot => ({ value: slot, text: slot }));
                    this.$refs.rescheduleModal.$refs.commonModal.show();
                });
            },
            saveReschedule() {
                CoopBusinessPointService.reschedule(this.rescheduleForm.id, this.rescheduleForm.time).then(() => {
                    this.$toast.success("Randevu saati başarıyla değiştirildi.");
                    this.$refs.rescheduleModal.$refs.commonModal.hide();
                    this.getRows();
                });
            },
            deleteParticipation(id) {
                CoopBusinessPointService.deleteParticipation(id).then(() => {
                    this.$toast.success("Katılım başarıyla silindi.");
                    this.getRows();
                });
            },
            downloadCv(row) {
                this.$toast.success(`${row.cv_name} indiriliyor...`);
            }
        },
        created() {
            this.getRows();
        }
    };
</script>
